module.exports = __webpack_public_path__ + "static/media/Slide30.6e20bcf3.jpg";